import React, { useState } from 'react';
import { Copy, Check, Download } from 'lucide-react';
import { Button } from './ui/button';

const ResultsPanel = ({ cityName, centroid, isLoading }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    if (!centroid) return;
    const text = `${centroid.lat.toFixed(6)}, ${centroid.lng.toFixed(6)}`;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const exportData = () => {
    if (!centroid) return;
    const data = {
      city: cityName,
      timestamp: new Date().toISOString(),
      centroid: { latitude: centroid.lat, longitude: centroid.lng }
    };
    const content = JSON.stringify(data, null, 2);
    const blob = new Blob([content], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `geocenter_${cityName.split(',')[0].replace(/\s+/g, '_')}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  if (!centroid || isLoading) return null;

  return (
    <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-lg border border-slate-200 p-4">
      <div className="text-center mb-3">
        <h3 className="font-semibold text-slate-800 truncate">{cityName.split(',')[0]}</h3>
        <p className="text-xs text-slate-500">Географический центр</p>
      </div>
      
      <div className="grid grid-cols-2 gap-4 mb-3">
        <div className="text-center">
          <span className="text-xs text-slate-500 block">Широта</span>
          <span className="font-mono text-sm font-medium text-slate-800">{centroid.lat.toFixed(6)}</span>
        </div>
        <div className="text-center">
          <span className="text-xs text-slate-500 block">Долгота</span>
          <span className="font-mono text-sm font-medium text-slate-800">{centroid.lng.toFixed(6)}</span>
        </div>
      </div>

      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={copyToClipboard}
          className="flex-1 h-8 text-xs"
        >
          {copied ? <Check className="h-3 w-3 mr-1 text-green-600" /> : <Copy className="h-3 w-3 mr-1" />}
          {copied ? 'Скопировано' : 'Копировать'}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={exportData}
          className="flex-1 h-8 text-xs"
        >
          <Download className="h-3 w-3 mr-1" />
          Скачать
        </Button>
      </div>
    </div>
  );
};

export default ResultsPanel;
